import { useTranslation } from '@wix/yoshi-flow-editor';
import { TranslationKey } from '~reviews/locale-types';

export type TranslationsFn = (key: TranslationKey, params?: any) => string;

export const useTranslate = () => {
  const { t } = useTranslation();
  return t as TranslationsFn;
};
